export default "__VITE_ASSET__e30b3d70__"